// Nov 2 to Nov 30, midnight to midnight Eastern
export const CYBER_MONTH_DISCOUNT_CODE = Date.UTC(2026, 10, 2, 5) <= Date.now() &&
  Date.now() < Date.UTC(2026, 11, 1, 5) && {
    code: 'BLACKFRIDAY',
    percent_off: 20,
  };

export function calculateDiscount(discountCode, price) {
  if (!discountCode) return 0;
  if (discountCode.subscription_trial) return price;
  if (discountCode.discount_type === 'percentage') return Math.round(price * discountCode.amount) / 100;
  else return Math.min(price, discountCode.amount);
}

export function getDiscountCodeCheckoutLabel(discountCode) {
  return (
    discountCode &&
    `${discountCode.name && discountCode.name !== discountCode.code ? discountCode.name : 'Discount Code'} (${discountCode.code})`
  );
}

export const DISCOUNT_TYPES = {
  percentage: {
    label: 'Percentage',
    description: 'Discount a percentage of total value',
  },
  fixed: {
    label: 'Fixed',
    description: 'Discount a fixed dollar amount',
  },
};

export const USAGE_TYPES = {
  unlimited: {
    label: 'Unlimited usage',
    description: '',
  },
  once_per_user: {
    label: 'Once per user',
    description: '',
  },
  one_time: {
    label: 'Only used 1 time',
    description: 'This discount code can only be used for a singe purchase',
  },
};

export const DURATION_TYPES = {
  once: { label: 'Once', description: '' },
  repeating: { label: 'Multiple Months', description: '' },
  forever: { label: 'Forever', description: '' },
};

export const EXTRA_PRODUCTS_CONFIG = {
  mcat_elite: { label: 'MCAT Elite 515' },
  mcat_self_paced: { label: 'MCAT Self-Paced' },
  lsat_elite: { label: 'LSAT Elite 170' },
  lsat_self_paced: { label: 'LSAT Self-Paced' },
  dat_elite: { label: 'DAT Elite' },
  dat_self_paced: { label: 'DAT Self-Paced' },
  sat_elite: { label: 'SAT Elite 1500' },
  sat_advantage: { label: 'SAT Advantage' },
  act_elite: { label: 'ACT Elite 33' },
  act_advantage: { label: 'ACT Advantage' },
};
